import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { VppApplication as VppAppMeta } from '@rocksoft/mdm-sdk-v2';
export interface VppApplication extends VppAppMeta {
  adamIdStr: string;
}

export type VppApplicationsState = EntityState<VppApplication>;

export function selectId(application: VppApplication) {
  return application.adamIdStr;
}

export const adapter: EntityAdapter<VppApplication> = createEntityAdapter<VppApplication>({
  selectId,
});

export const initialState: VppApplicationsState = adapter.getInitialState();
